import { ChevronRight, Settings } from 'lucide-react'

// import { useState } from 'react'

import { AWXCardholderStatus } from '@ankor-io/common/types/awx'
import type { CardholderSummary } from '@ankor-io/common/types/cards'

import { Badge } from '@/ui-components/Badge'
import { Dropdown, DropdownButton /*, DropdownItem, DropdownMenu*/ } from '@/ui-components/Dropdown'
import { Heading } from '@/ui-components/Heading'
import { Link } from '@/ui-components/Link'
import { Text } from '@/ui-components/Text'

// import { IssueCardModal } from '@/views/components/IssueCardModal'

type MainCardholderDetailsProps = {
  cardholder: CardholderSummary
}

export const MainCardholderDetails = ({ cardholder }: MainCardholderDetailsProps) => {
  // const [isIssueCardModalOpen, setIsIssueCardModalOpen] = useState(false)

  return (
    <>
      <div className="xl:w-[25rem] shrink-0 border rounded-lg shadow-sm dark:shadow-gray-800 border-gray-200 dark:border-gray-700">
        <div className="flex gap-2 items-center justify-between p-4 md:px-8 xl:p-4">
          <Heading level={3}>Cardholder Details</Heading>
          <Dropdown>
            <DropdownButton
              color="primary"
              className="flex items-center gap-x-1"
            >
              <Settings className="size-4" />
              Manage
            </DropdownButton>
            {/* <DropdownMenu anchor="bottom end">
              <DropdownItem onClick={() => setIsIssueCardModalOpen(true)}>Issue new card</DropdownItem>
            </DropdownMenu> */}
          </Dropdown>
        </div>
        <hr className="border-gray-200 dark:border-gray-700" />
        <div className="p-4 md:p-8 xl:p-4">
          <div className="flex gap-x-2 items-center">
            <Heading level={4}>
              {cardholder.identity.firstName} {cardholder.identity.lastName}
            </Heading>
            <Badge color={cardholder.status === AWXCardholderStatus.READY ? 'green' : 'orange'}>
              {cardholder.status}
            </Badge>
          </div>
          <Text>{cardholder.identity.email}</Text>
          <hr className="my-4 border-gray-200 dark:border-gray-700" />
          <div className="grid grid-cols-2 gap-x-2 gap-y-1">
            <span className="text-xs text-gray-500 dark:text-gray-400">Legal name</span>
            <span className="text-xs text-gray-500 dark:text-gray-400">Cardholder ID</span>
            <span className="text-xs font-bold text-gray-900 dark:text-white">
              {cardholder.identity.firstName} {cardholder.identity.lastName}
            </span>
            <span className="text-xs font-bold text-gray-900 dark:text-white">{cardholder.id}</span>
          </div>
          <Link
            className="mt-4 flex items-center gap-x-1 text-sm text-primary-600 dark:text-primary-400"
            to={`/users/user-details/${cardholder.id}`}
          >
            View user details
            <ChevronRight className="size-4" />
          </Link>
        </div>
      </div>

      {/* TODO: Bring in with issue 389 to avoid nasty conflicts */}
      {/* <IssueCardModal
        isOpen={isIssueCardModalOpen}
        onClose={() => setIsIssueCardModalOpen(false)}
        preselectedCardholder={cardholder}
      /> */}
    </>
  )
}

export default MainCardholderDetails
